module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-overview-settings__settings"
  }, [_c('div', {
    staticClass: "task-overview-settings__settings-container"
  }, [_c('h2', {
    staticClass: "marg-1-bottom"
  }, [_vm._v("1. Skjul antal timer tildelt på visse opgaver")]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__body"
  }, [_c('div', {
    staticClass: "d-explainer-box text-explainer text-explainer__error"
  }, [_c('svg', {
    staticClass: "tw-icon icon-help",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
    }
  })]), _vm._v("\n        Aktivér denne indstilling for at skjule timepuljen for alle opgaver med mindre end et bestemt antal timer\n        (f.eks. 60 timer) for alle andre end administratorer. Selve opgaverne vil stadig være synlige for lærerne, men\n        de vil ikke kunne se det specifikke antal timer, der er allokeret til dem.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "d-label-and-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setIsActive.apply(null, arguments)
      }
    }
  }, [_c('label', {
    staticClass: "d-label color-dark"
  }, [_vm._v("Skjul timepuljer")]), _vm._v(" "), _c('div', {
    staticClass: "do-switch",
    class: {
      'do-switch--active': _vm.isActive
    }
  })]), _vm._v(" "), (_vm.isActive) ? _c('div', [_c('div', {
    staticClass: "prep-factor-input marg-1-bottom"
  }, [_c('p', {
    staticClass: "italic"
  }, [_vm._v("Indtast det antal timer, hvor timepuljen på opgaver skal skjules")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thresholdToHideTaskHours),
      expression: "thresholdToHideTaskHours"
    }],
    ref: "the_input_field",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.thresholdToHideTaskHours)
    },
    on: {
      "blur": _vm.onSave,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSave.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thresholdToHideTaskHours = $event.target.value
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "task-overview-settings__settings-container"
  }, [_c('h2', [_vm._v("2. Visning af fordeling af puljer")]), _vm._v(" "), _c('h4', {
    staticClass: "italic marg-1-bottom"
  }, [_vm._v("Fordelingen er med til at give medarbejdere et overblik over deres arbejdstid og\n      puljer herunder som f.eks. undervisning.\n      Visse felter vises kun, hvis brugeren har fået tidelt timer timer i puljen f.eks. SFO.")]), _vm._v(" "), _c('div', {
    staticClass: "d-table__container"
  }, [_c('table', {
    staticClass: "d-table marg-1-bottom d-table__overview"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "td-toggler",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSettings('work_hours')
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.getIsOn('work_hours')
    }
  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Arbejdstid")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("100%")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("\n            1642.8\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("1586")]), _vm._v(" "), _c('td', {
    staticClass: "is-number",
    staticStyle: {
      "background-color": "rgba(62, 207, 142, 0.57)"
    }
  }, [_vm._v("56.8")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "td-toggler",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSettings('teaching')
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.getIsOn('teaching')
    }
  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Undervisning")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("49%")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("800")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("693.88")]), _vm._v(" "), _c('td', {
    staticClass: "is-number",
    staticStyle: {
      "background-color": "rgb(62, 207, 142)"
    }
  }, [_vm._v("106.13")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "td-toggler",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSettings('tasks')
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.getIsOn('tasks')
    }
  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Øvrige Opgaver")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("24%")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("400")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("398")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSettings('preparation')
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.getIsOn('preparation')
    }
  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Forberedelse")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("24%")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("400")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("400")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSettings('pool')
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.getIsOn('pool')
    }
  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Lokalpulje")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("5%")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("80")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "is-number",
    staticStyle: {
      "background-color": "rgba(62, 207, 142, 0.8)"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSettings('substitute_hours')
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.getIsOn('substitute_hours')
    }
  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Vikartimer")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("1%")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("20")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "is-number",
    staticStyle: {
      "background-color": "rgba(62, 207, 142, 0.17)"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSettings('teaching_and_sub')
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.getIsOn('teaching_and_sub')
    }
  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Undervisning + Vikartimer (UV-timer)")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("820")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("696.88")]), _vm._v(" "), _c('td', {
    staticClass: "is-number",
    staticStyle: {
      "background-color": "rgb(62, 207, 142)"
    }
  }, [_vm._v("123.12")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSettings('club')
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.getIsOn('club')
    }
  })], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("3%")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("57.2")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.taskCategories), function(taskCategory) {
    return _c('tr', {
      key: taskCategory.id
    }, [_c('td', [_c('div', {
      staticClass: "td-toggler",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleOwnPool(taskCategory.name)
        }
      }
    }, [_c('AppToggle', {
      attrs: {
        "allowChanges": false,
        "propOn": _vm.getIsOwnPoolOn(taskCategory.name)
      }
    })], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(taskCategory.name))])])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Vis")]), _vm._v(" "), _c('th', [_c('h4', [_vm._v("Standardpuljer")])]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Tildelt")]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Skemalagt")]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Forskel")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "d-badge d-badge--warning"
  }, [_vm._v("SFO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', [_vm._v("Vis optælling fra egne kategorier")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-95ca2a2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskOverviewSettings/TaskOverviewSettingsSettings.vue
// module id = 1724
// module chunks = 1